import * as ActionType from "../actionType";
import { fetchPromotionCategoriesApi } from "../../services/page/promotioncategories";

const getPromotionCategoriesAction = () => {
  return async dispatch => {
    dispatchPromotionCategories(dispatch);
  };
};

const dispatchPromotionCategories = dispatch => {
  fetchPromotionCategoriesApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_PROMOTIONCATEGORIES,
      data
    });
  });
};

export { getPromotionCategoriesAction, dispatchPromotionCategories };


// WEBPACK FOOTER //
// ./src/actions/page/promotioncategories.js